import {OnDeleteTaskSingleVoyage} from "@containers/singleVoyage/tasks/table/types/events";
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import {useCallback} from "react";

export function useDeleteTaskMutateSingleVoyage() {
    const {
        setTasks,
        tasksLocalCreateIds,
        setTasksLocalDeleteIds,
    } = useRootContextMutateSingleVoyage()

    const onDelete: OnDeleteTaskSingleVoyage = useCallback(async ({task}) => {
        if (!tasksLocalCreateIds.includes(Number(task.id))) {
            setTasksLocalDeleteIds((prev) => [
                ...prev,
                task.id
            ])
        }
        setTasks((prev) => prev.filter((oldTask) => oldTask.id?.toString() !== task?.id?.toString()))
    }, [tasksLocalCreateIds])

    return {
        onDelete
    }
}
